import React from "react";
import {
  Box, Card, Grid, Container, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const supplierSKUMappingData = this.props.SupplierSKUMappingData;
    const searchData = this.props.searchData;
    const date = this.props.Date;
  
   const cellStyle = {
      border: '1px solid black',
      padding: '2px 6px',
      fontSize: '0.9rem',
    };
    return (
      <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
        <h3><center><u>Supplier SKU Mapping Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{searchData.groupName}</center></h4>
         <div>&nbsp;</div>
         <h4><center>{searchData.factoryName}</center></h4>
        <div>&nbsp;</div>
        <h4><center>{date}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px' }}>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow style={{ border: "1px solid black" }}>
                    <TableCell align='center' style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Supplier Name</TableCell>
                    <TableCell align='center' style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>Account Code Name</TableCell>
                    <TableCell align='center' style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>SKU Category Name</TableCell>
                    <TableCell align='center' style={{ fontWeight: "bold", border: "1px solid black", fontSize: '16px', width: '20%' }}>SKU Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {supplierSKUMappingData.map((data, index) => (
                    <TableRow key={index} style={{ border: "1px solid black" }}>
                       <TableCell component="th" scope="row" align="left" style={cellStyle}> {data.supplierName}</TableCell>
                       <TableCell component="th" scope="row" align="left" style={cellStyle}> {data.budgetCodeName}</TableCell>
                       <TableCell component="th" scope="row" align="left" style={cellStyle}> {data.skuCategoryName}</TableCell>
                       <TableCell component="th" scope="row" align="left" style={cellStyle}> {data.skuMasterName}</TableCell>         
                    </TableRow>
                    
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}
